import React, {useState, useRef, useEffect} from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const Popup = styled.div`
  display: ${({$visible}) => $visible ? 'block' : 'none'};
  z-index: 9;
  position: absolute;
  top: calc(100% + 12px);
  right: calc(50% - 16px);
  padding: 10px 15px;
  background-color: #fff;
  border: 1px solid #999;
  font-size: 16px;
  line-height: 1.2;
  white-space: nowrap;

  &::after {
    content: '';
    position: absolute;
    top: -6px;
    right: 10px;
    border: 1px solid #999;
    border-width: 1px 0 0 1px;
    background-color: #fff;
    transform: rotate(45deg);
    width: 10px;
    height: 10px;
  }
`;

const Tooltip = ({children, label}) => {
  const [show, setShow] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    clearTimeout(timer.current);

    if (isHovered) {
      timer.current = setTimeout(() => {
        setShow(true);
      }, 500);
    } else {
      setShow(false);
    }
  }, [isHovered]);

  const onMouseEnter = () => {
    setIsHovered(true);
  };

  const onMouseLeave = () => {
    setIsHovered(false);
  };

  if(!label) {
    return children;
  }

  return (
    <Wrapper onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <Popup $visible={show}>{label}</Popup>
      {children}
    </Wrapper>
  );
};

export default Tooltip;


// WEBPACK FOOTER //
// ./src/components/Tooltip/Tooltip.jsx